var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.96826 8.36242V6.53238H3.13758C2.43848 6.53238 2.43848 5.46848 3.13758 5.46848H4.96826V3.63779C4.96826 2.93869 6.03217 2.93869 6.03217 3.63779V5.46848H7.86221C8.56131 5.46848 8.56131 6.53238 7.86221 6.53238H6.03217V8.36242C6.03217 9.06152 4.96826 9.06152 4.96826 8.36242ZM5.5 11.5C8.53768 11.5 11 9.03789 11 6C11 2.96232 8.53768 0.5 5.5 0.5C2.46232 0.5 0 2.96232 0 6C0 9.03768 2.46232 11.5 5.5 11.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.ace0e2bc9d29d3be42861a9adb799a78.svg";
export { ForwardRef as ReactComponent };